<template>
    <router-page />
</template>